import { useState, useEffect, useContext } from 'react';
import styles from './styles.module.scss';
import { Board } from '../../components/Board';
import 'moment/locale/pt';
import { Loading } from '../../components/Loading';
import { User } from '../../types';
import { verifyRoutePermissions } from '../../globalFunctions';
import { NavButton } from '../../components/NavButton';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadModulesStatus } from '../Trilogic/HubRoute/requestHandlers';
import { ModuleStatus } from '../Trilogic/HubRoute/types';
import { useModule } from '../../hooks/useModule';
import { getModuleJogadasBySlug, destroyModule } from './requestHandlers';
import { MessageContext } from '../../providers/MessageProvider';
import { AlertDialog, AlertDialogType } from '../../components/AlertDialog';
import { saveExerciseChanges } from './requestHandlers';
import ModuleForm from './createModuleForm';
import ModuleCard from './ModuleCard';
import { saveModuleChanges } from '../LogicManager/LogicManagerMainRoute/EditRoute/LogicManagerModuleRoute/LogicManagerModuleDetailRoute/requestHandlers';
export const LogicMakerModulos = () => {
    const [isLoadingPage, setIsLoadingPage] = useState<boolean>(false);
    const [modulesStatus, setModulesStatus] = useState<ModuleStatus[]>();
    const boardRef = useRef<HTMLDivElement>(null);
    const [exercises, setExercises] = useState<any>();
    const [moduleSlug, setModuleSlug] = useState<string>(
        sessionStorage.getItem('selectedModule') || 'DescNarrativa'
    );
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const navigate = useNavigate();
    const moduleData = useModule(moduleSlug);
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const [alertDialogProps, setAlertDialogProps] = useState<AlertDialogType>();
    const [openAlert, setOpenAlert] = useState<boolean>(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [openModuleForm, setOpenModuleForm] = useState<boolean>(false);
    const [editModule, seteditModule] = useState<any | undefined>(undefined);
    // Carrega status dos módulos
    const handleLoadModulesStatus = async () => {
        setIsLoadingPage(true);
        const result = await loadModulesStatus(userAuth.token, navigate);
        setIsLoadingPage(false);

        const resultado = await Promise.all(
            result.modules.map(async modulo => {
                return { ...modulo }; // retorna uma cópia do módulo com a nova propriedade
            })
        );
        console.log(resultado);
        if (result && !('error' in result)) {
            setModulesStatus(resultado);
        }
    };

    // On mount: pega usuário
    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'logicmanager.classes'],
            navigate
        );
        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, [navigate]);

    // Sempre que token mudar, recarrega módulos
    useEffect(() => {
        if (userAuth.token) {
            handleLoadModulesStatus();
        }
    }, [userAuth.token]);

    useEffect(() => {
        if (!moduleData.isLoading && moduleData.data) {
            setExercises(moduleData.data.exercises ?? []);
            setIsLoadingPage(false);
        }
    }, [moduleData.data, moduleData.isLoading]);

    const criarModulo = () => {
        setOpenModuleForm(true);
    };

    const ConfirmarDeletar = id => {
        setOpenAlert(true);

        setAlertDialogProps({
            title: 'Deseja deletar este módulo?',
            message:
                'Ao deletar este todo as suas fases e todas as suas jogadas serão permanentemente deletador da plataforma',
            options: [
                {
                    text: 'Cancelar',
                    action: () => {},
                    type: 'success'
                },
                {
                    text: 'Deletar',
                    action: async () => {
                        await destroyModule(userAuth.token, id, navigate);
                        handleLoadModulesStatus();
                        setOpenMessage(true);
                        setMessage({
                            type: 'success',
                            content: 'Módulo deletado com sucesso'
                        });
                    },
                    type: 'error'
                }
            ]
        });
    };

    const publicarExercicio = async (id: number) => {
        setOpenMessage(true);
        try {
            const success = await saveModuleChanges(
                userAuth.token,
                navigate,
                { id: id, is_active: 1 },
            );
            if (success) {
                setModulesStatus((prev: any) =>
                    Object.values(prev).map((ex: any) =>
                        ex.id === id ? { ...ex, is_active: 1 } : ex
                    )
                );
                setMessage({
                    type: 'success',
                    content: 'Exercicio publicado: '
                });
            } else {
                setMessage({
                    type: 'error',
                    content: 'erro ao publicar exercicio'
                });
            }
        } catch {}
    };

    const PrivarExercicio = async (id: number) => {
        setOpenMessage(true);
        try {
            const success = await saveModuleChanges(
                userAuth.token,
                navigate,
                { id: id, is_active: 0 },
            );
            if (success) {
                setModulesStatus((prev: any) =>
                    Object.values(prev).map((ex: any) =>
                        ex.id === id ? { ...ex, is_active: 0 } : ex
                    )
                );
                setMessage({
                    type: 'success',
                    content: 'Exercicio privado: '
                });
            } else {
                setMessage({
                    type: 'error',
                    content: 'erro ao privar exercicio'
                });
            }
        } catch {}
    };
    useEffect(() => {}, [moduleSlug]);
    const close = () => {
        setOpenModuleForm(false);
        seteditModule(undefined);
        handleLoadModulesStatus();
    };
    return (
        <div className={styles.wrapper} ref={boardRef}>
            {(openModuleForm || editModule) && <ModuleForm editModule={editModule} close={close} />}
            <Board wrapperClass={`${styles.board} ${styles.big}`}>
                {!modulesStatus ? (
                    <Loading />
                ) : (
                    <>
                        {alertDialogProps && (
                            <AlertDialog
                                setOpen={setOpenAlert}
                                open={openAlert}
                                title={alertDialogProps.title}
                                message={alertDialogProps.message}
                                options={alertDialogProps.options}
                            />
                        )}
                        <h1 className={styles.titleFases}>Lista de Módulos</h1>

                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                overflowY: 'auto',
                                height: '85%'
                            }}
                        >
                            {exercises &&
                                modulesStatus?.sort((a,b) => a.sort - b.sort).map((ex: any) => (
                                    <>
                                        <ModuleCard
                                            key={ex.id}
                                            name={ex.name}
                                            jogadas={ex.total}
                                            usuarios={ex.Usuarios}
                                            taxa={ex.TaxaAcertos}
                                            completaram={ex.UsuariosCompletaram}
                                            id={ex.id}
                                            image={ex.image}
                                            destroy={ConfirmarDeletar}
                                            editar={() => {
                                                seteditModule(ex);
                                            }}
                                            publico={ex.is_active}
                                            publicar={() => {
                                                publicarExercicio(ex.id);
                                            }}
                                            privar={() => {
                                                PrivarExercicio(ex.id);
                                            }}
                                        />
                                    </>
                                ))}

                            <div
                                onClick={criarModulo}
                                className={styles.card}
                                style={{
                                    width: '12vw',
                                    height: '12vw',
                                    cursor: 'pointer',
                                    borderColor: 'green',
                                    color: 'green',
                                    fontSize: '5vw',
                                    fontWeight: '900',
                                    textShadow: `
                  -2px -2px 0 green,
                   2px -2px 0 green,
                  -2px  2px 0 green,
                   2px  2px 0 green
                `
                                }}
                            >
                                +
                            </div>
                        </div>
                    </>
                )}
            </Board>

            <NavButton
                direction='left'
                style={{ left: '1vw', top: '2vw', zIndex: '20' }}
                onClick={() => navigate('/manager')}
            />
        </div>
    );
};
